<div class="container-fluid">
    <div class="row">
        <ng-container *ngIf="engine">
            <div class="col-md-6">
                <div class="overflow-auto scroll-style">
                    <div class="column-height pe-2">
                        <data-grid
                            #dataGrid
                            testId="datev-unmapped-accounts"
                            rowTestIdPrefix="datev-unmapped-"
                            rowTestIdField="accountNumber"
                            [options]="rawAccountsGridUiData"
                            (selectedRows)="onRowsSelected($event)"
                            (deletedRows)="onDeletedRows($event)"
                            (actionEvent)="onAction($event)"
                        ></data-grid>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="col-md-6 px-0">
            <div class="overflow-auto scroll-style">
                <div class="column-height">
                    <templates-template-account-mapping-form
                        [businessModel]="businessModel"
                        [currency]="currency"
                        [reportLocale]="reportLocale"
                        [engine]="this.engine"
                        [type]="type"
                        [hasPreviousData]="hasPreviousData"
                        [cashAndCashFli]="cashAndCashFli"
                        [profitOfTheYearFliName]="profitOfTheYearFliName"
                        [errorInProfitFli]="errorInProfitFli"
                        [isAutomaticTransferOfAnnualResultEnabled]="isAutomaticTransferOfAnnualResultEnabled"
                        [isCashFlowTypeForFliUsed]="isCashFlowTypeForFliUsed"
                        [disableEditingPreviousYearValue]="disableEditingPreviousYearValue"
                        [supportOperation]="supportOperation"
                        (addOrUpdateAccountInActiveReport)="onAddOrUpdateActiveReport($event)"
                        (fliOrGroupDeleted)="onFliOrGroupDeleted($event)"
                    >
                    </templates-template-account-mapping-form>
                </div>
            </div>
        </div>
    </div>
</div>

<ham-modal
    *ngIf="showSummarizeAccountsModal"
    title="{{ 'aumico_templates_summarized_accounts_modal_title' | i18next }}"
    saveText="{{ 'aumico_templates_summarized_accounts_modal_title_save_button' | i18next }}"
    cancelText="{{ 'aumico_templates_summarized_accounts_modal_title_cancel_button' | i18next }}"
    [showCancelButton]="true"
    (cancel)="onCloseSummaryModal()"
    (save)="onSummarizeAccounts()"
    [addHorizontalLineBeforeButtons]="true"
    size="lg"
>
    <div class="summary-container">
        <div class="summary-section">
            <div class="summary-table-header">
                <span>{{ 'aumico_templates_summarized_accounts_modal_table_raw_accounts' | i18next }}</span>
                <span>{{ columns[2]?.name | dateLocale }}</span>
                <span *ngIf="hasPreviousData">{{ columns[3]?.name | dateLocale }}</span>
            </div>
            <div class="summary-account-row" *ngFor="let acc of accountsForSummary">
                <span>
                    <span>{{ acc.accountNumber }}</span>
                    <span style="margin-left: 16px">{{ acc.displayName }}</span>
                </span>
                <span class="text-end">{{ acc.closingBalance | finNumber }}</span>
                <span *ngIf="hasPreviousData" class="text-end">{{ acc.openingBalance | finNumber }}</span>
            </div>
        </div>
        <div class="summary-separator"></div>
        <div class="summary-section">
            <div class="summary-table-header">
                <span>{{ 'aumico_templates_summarized_accounts_modal_table_sum_account' | i18next }}</span>
                <span>{{ columns[2]?.name | dateLocale }}</span>
                <span *ngIf="hasPreviousData">{{ columns[3]?.name | dateLocale }}</span>
            </div>
            <div class="summary-account-row" *ngIf="summarizedAccount">
                <span
                    ><span>{{ summarizedAccount.accountNumber }}</span
                    ><span style="margin-left: 16px"> {{ summarizedAccount.displayName }}</span>
                </span>
                <span class="text-end">{{ summarizedAccount.closingBalance | finNumber }}</span>
                <span *ngIf="hasPreviousData" class="text-end">{{ summarizedAccount.openingBalance | finNumber }}</span>
            </div>
        </div>
    </div>
</ham-modal>

<ham-confirm-decline-modal
    *ngIf="showUnsummarizeConfirmModal"
    (action)="onConfirmUnsummarize()"
    (cancel)="onCancelUnsummarize()"
    actionBtnText="{{ 'aumico_templates_summarized_accounts_undo_yes_button' | i18next }}"
    noActionBtnText="{{ 'aumico_annual_report_cancel_button' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [icon]="'assets/hamIcons/redo.svg'"
        text="{{ 'aumico_templates_summarized_accounts_undo_question' | i18next }}"
        [useIconShapes]="true"
        [iconShapeVariant]="'red'"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    *ngIf="summarizedAccountError !== undefined"
    (action)="onConfirmError()"
    actionBtnText="{{ 'aumico_reports_cant_activate_fcp_ok' | i18next }}"
    hideCancelButton="true"
>
    <ham-general-confirm-decline-modal-body
        [icon]="'assets/hamIcons/redo.svg'"
        [text]="summarizedAccountError"
        [useIconShapes]="true"
        [iconShapeVariant]="'red'"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
